export default {
    baseUrl: {
        // 正式环境解锁此处配置
        dev: 'https://test.cgmcare.cn/api',
        pro: 'https://td.cgmcare.cn/api'
    }
}